import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Avatar from '../Avatar';
import { flowRight as compose } from 'lodash';
import UnreadThreadsQuery from '../Message/getUnreadThreads.graphql';
import { withQuery } from '../../hoc/withGraphql';

import MenuIcon from './MenuIcon';
import history from '../../core/history';
import s from './DropDownMenu.css';

class DropDownMenu extends React.Component {

  static propTypes = {
    allUnreadThreadsCount: PropTypes.shape({
      loading: PropTypes.bool.isRequired,
      getUnreadCount: PropTypes.shape({
        total: PropTypes.number.isRequired,
      }),
    }),
    isTransparentHeader: PropTypes.bool,
  };

  static defaultProps = {
    allUnreadThreadsCount: {
      loading: true,
      getUnreadCount: {
        total: 0,
      },
    },
    isTransparentHeader: false,
  };


  render() {

    const { allUnreadThreadsCount: { loading, getUnreadCount }, isTransparentHeader } = this.props;
    let count = 0;
    if (!loading && getUnreadCount != null) {
      count = getUnreadCount.total != null ? getUnreadCount.total : 0;
    }
    const isNewMessage = count > 0;


    const pathname = history.location && history.location.pathname;
    const isWhyHost = pathname && pathname.startsWith('/whyhost');
    const iconFill = isTransparentHeader
      ? '#ffffff'
      : (isWhyHost ? 'var(--primary-color)' : 'var(--primary-color)');

    return (
      <div className={s.menuBg}>
        {isNewMessage && <span className={cx(s.notification, 'notificationHeaderRTL')} />}
        <span>
          <MenuIcon fill={iconFill} />
        </span>
        <span>
          <Avatar
            isUser
            type={'small'}
            height={50}
            width={55}
            className={s.userAvatar}
            isTransparentHeader={isTransparentHeader}
          />
        </span>
      </div>
    );
  }
}

export default compose(
  withStyles(s),
  withQuery(UnreadThreadsQuery, {
    name: 'allUnreadThreadsCount',
    options: {
      ssr: false,
    },
  }),
)(DropDownMenu);
